import styled from 'styled-components';

import Icon from 'components/Icon';
import NavLink from 'components/NavLink';
import { black, border1, lightGray } from 'utils/style/colors';

export const matchMenuLinkStyle: React.CSSProperties = {
  backgroundColor: '#e6f7ff',
};

export const PopoverButton = styled('a')`
  color: inherit;
  cursor: pointer;
  display: inline-block;
`;

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
`;

export const PopoverMenu = styled('ul')`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  background: var(--exact-white);
  border-radius: 10px;
  list-style-type: none;
  margin: 0;
  outline: none;
  overflow: hidden;
  width: 100%;
  padding: 0;
`;

export const MenuItem = styled('li')`
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 2rem;
  text-align: ${(props) => props.theme.textAlign};
  transition-delay: 0s;
  transition-duration: 0.3s;
  transition-property: all;
  transition-timing-function: ease;
  white-space: nowrap;
  .icon {
    margin-inline-end: 0.5rem;
  }
`;

export const MenuDivider = styled('li')`
  background-color: #e8e8e8;
  height: 1px;
  line-height: 0;
  margin: 4px 0;
  overflow: hidden;
`;

export const MenuLink = styled(NavLink).attrs({
  matchStyle: matchMenuLinkStyle,
} as any)`
  width: 100%;
  background-color: transparent;
  color: ${black};
  display: flex;
  padding: 0.25rem 0.75rem;
`;

export const StyledIcon = styled(Icon)`
  padding-left: 8px;
  @media only screen and (max-width: 769px) {
    padding-left: 0;
  }
`;

export const HeaderSearchWrapper = styled('span')`
  display: inline-flex;
  flex-direction: column;
  flex: 1;
  justify-content: center;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  position: relative;
  text-align: center;
  @media only screen and (max-width: 769px) {
    padding-right: 0;
    text-align: right;
  }
  @media only screen and (max-width: 769px) {
    padding-right: 0;
    text-align: right;
  }
`;

export const HeaderItem = styled('span')`
  flex: 1;
  overflow: hidden;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const SearchIcon = styled(Icon)`
  align-self: flex-end;
  cursor: pointer;
  padding: 0.5rem;
  position: absolute;
  // top: 0;
  // left: 0;
`;

export const SearchInput = styled('input')`
  background-color: ${lightGray} !important;
  border-radius: 20px !important;
  border: ${border1} !important;
  box-sizing: border-box !important;
  font-size: 12px !important;
  height: 2rem !important;
  margin: 0 !important;
  padding: 0 1em 0 1em !important;
  &::placeholder {
    color: #96b1ac;
  }
  &:focus {
    background-color: var(--exact-white) !important;
    border: 1px solid #34c8b6 !important;
    box-shadow: 0 0 2px #34c8b6 !important;
  }
  &:hover {
    border: 1px solid #34c8b6 !important;
  }
`;

export const TaskLoadingIconStyle: React.CSSProperties = { left: '0.8rem' };

export const RouteName = styled('div')`
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  @media only screen and (max-width: 769px) {
    display: none;
  }
`;

export const UserName = styled('span')`
  user-select: none;
  @media only screen and (max-width: 400px) {
    display: none !important;
  }
`;

export const UserNameList = styled('span')`
  display: list-item !important;
  margin: 1rem;
`;
